import { t } from '@base/utils/helpers';
import { container } from 'tsyringe';
import GameMenuButtons, { MenuButton } from './gameMenuButtons';
import { IGameService } from '@base/features/game/model/interfaces';
import { IPlayersOnlineRepository } from '@base/features/player/model/interfaces';
import Codes from '@base/features/socket/codes';

export default function AbortGame(props: { closeModal: () => void }) {
  const playersOnlineRepository: IPlayersOnlineRepository = container.resolve('playersOnlineRepository');
  const gameService: IGameService = container.resolve('gameService');

  const handleAbort = () => {
    gameService.sendPlay(
      Codes.PlayCommand.ABORT,
      playersOnlineRepository.me?.getPid(),
      playersOnlineRepository.me?.getTable()?.tid
    );
    playersOnlineRepository.me
      ?.getTable()
      ?.getGameState()
      .setStatusMessage(t('waiting_for_opponent_confirmation'));
  };

  const buttons: MenuButton[] = [
    {
      title: t('abort'),
      onClick: () => {
        handleAbort();
        props.closeModal();
      },
    },
    {
      title: t('cancel'),
      onClick: () => props.closeModal(),
    },
  ];

  return (
    <>
      <p>{t('sure_want_abort_current_game')}</p>
      <GameMenuButtons buttons={buttons} />
    </>
  );
}
